import styled from 'styled-components';
import { ReactComponent as WarningIcon } from 'assets/images/icons/warning.svg';

export const Warning = styled(WarningIcon)`
  path {
    fill: rgba(9, 21, 38, 0.6);
    fill-opacity: 1;
  }
`;
